// src/screens/superadmin/settings/Settings.jsx - PAKISTANI DATA
import { useEffect, useState, useContext } from "react";
import { Col, Container, Row, Card, Tab, Nav, Form } from "react-bootstrap";
import {
  FaBell,
  FaSave,
  FaLock,
  FaUser,
  FaDollarSign,
  FaEdit,
  FaUniversity,
  FaTrash,
  FaPlus,
  FaTimes,
} from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { useSearchParams } from "react-router-dom";
import "../../../assets/css/admin/settings/SystemSettings.css";
import Button from "../../../components/general/button/Button";
import AdminLayout from "../../../layouts/AdminLayout";
import MyContext from "../../../context/MyContext";
import { SettingsPageSkeleton } from "../../../components/general/skeleton/SkeletonBlock";

// ── inline error styles — jab tak SystemSettings.css mein dedicated
// error classes nahi ban jatin, red border/message ye reuse karte hain ──
const errBorder = { borderColor: "#dc3545" };
const errText = { color: "#dc3545", fontSize: 12, marginTop: 4, marginBottom: 0 };

const SystemSettings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("profile");

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam) {
      setActiveTab(tabParam);
    }
  }, [searchParams]);

  const { baseUrl, loggedInAdmin, authToken, regExpChecker } = useContext(MyContext);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [adminProfile, setAdminProfile] = useState("");
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  // ── Bank Accounts (Payout) — same pattern as Seller Settings ──
  const [bankAccounts, setBankAccounts] = useState([]);
  const [showBankForm, setShowBankForm] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  const [bankName, setBankName] = useState("");
  const [accountTitle, setAccountTitle] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [isPrimary, setIsPrimary] = useState(false);
  const [bankNameError, setBankNameError] = useState("");
  const [accountTitleError, setAccountTitleError] = useState("");
  const [accountNumberError, setAccountNumberError] = useState("");

  // ── Edit modes ──
  const [isProfileEditing, setIsProfileEditing] = useState(false);
  const [isPaymentEditing, setIsPaymentEditing] = useState(false);

  // ── NEW: Profile tab field-level errors ──
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  // ── Sirf woh settings jo actually backend mein kahin use hoti
  //     hain — Tax Rate, Shipping Fee, Commission Rate, Delivery
  //     Deduction Rate hata diye gaye (koi controller kahin bhi
  //     inhe read nahi kar raha tha) ──
  const [paymentSettings, setPaymentSettings] = useState({
    commissionRate: "10",
    deliveryDeductionRate: "10",
    sellerWithdrawLimit: "50000",
    deliveryTopupLimit: "20000",
    minimumWalletBalance: "200",
    // ── NEW: Cancellation-penalty settings ──
    sellerCancellationPenalty: "100",
    deliveryCancellationPenalty: "50",
    customerCancellationFeePercent: "5",
  });

  // ── NEW: Payment tab field-level errors ──
  const [paymentErrors, setPaymentErrors] = useState({
    commissionRate: "",
    deliveryDeductionRate: "",
    sellerWithdrawLimit: "",
    deliveryTopupLimit: "",
    minimumWalletBalance: "",
    sellerCancellationPenalty: "",
    deliveryCancellationPenalty: "",
    customerCancellationFeePercent: "",
  });

  // ── Security ──
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  // ── NEW: Security tab field-level errors ──
  const [currentPasswordError, setCurrentPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  // ── Notifications ──
  const [emailNotification, setEmailNotification] = useState(true);
  const [inAppNotification, setInAppNotification] = useState(true);

  const togglePass = (key) =>
    setShowPasswords((prev) => ({ ...prev, [key]: !prev[key] }));
  //----------API Calling
  const viewAdminProfile = () => {
    axios
      .get(`${baseUrl}/admin/profile/viewAdminProfile`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.hasOwnProperty("error")) {
          setErrorMessage(response.data.error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        } else {
          const admin = response.data.admin;
          setAdminProfile(admin);
          setName(admin.name || "");
          setEmail(admin.email || "");
          setPhone(admin.phone || "");
          setEmailNotification(admin.emailNotification == 1);
          setInAppNotification(admin.inAppNotification == 1);
          setPaymentSettings({
            commissionRate: admin.commission_rate ?? "10",
            deliveryDeductionRate: admin.delivery_deduction_rate ?? "10",
            sellerWithdrawLimit: admin.seller_withdraw_limit ?? "50000",
            deliveryTopupLimit: admin.delivery_topup_limit ?? "20000",
            minimumWalletBalance: admin.minimum_wallet_balance ?? "200",
            sellerCancellationPenalty: admin.seller_cancellation_penalty ?? "100",
            deliveryCancellationPenalty: admin.delivery_cancellation_penalty ?? "50",
            customerCancellationFeePercent: admin.customer_cancellation_fee_percent ?? "5",
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Profile cannot load .",
        });
      });
  };

  useEffect(() => {
    if (authToken) {
      viewAdminProfile();
    } else {
      setLoading(false);
    }
  }, [authToken]);

  // ── NEW: Profile tab validation ──
  const validateAdminProfile = () => {
    let valid = true;

    const nameErr = regExpChecker("username", name);
    if (!name) {
      setNameError("Full name is required");
      valid = false;
    } else if (nameErr) {
      setNameError(nameErr);
      valid = false;
    } else setNameError("");

    const emailErr = regExpChecker("email", email);
    if (!email) {
      setEmailError("Email is required");
      valid = false;
    } else if (emailErr) {
      setEmailError(emailErr);
      valid = false;
    } else setEmailError("");

    if (phone) {
      const phoneErr = regExpChecker("phoneNumber", phone);
      if (phoneErr) {
        setPhoneError(phoneErr);
        valid = false;
      } else setPhoneError("");
    } else setPhoneError("");

    return valid;
  };

  const updateAdminProfile = () => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    axios
      .post(`${baseUrl}/admin/profile/updateAdminProfile`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Profile updated successfully!",
          });
          viewAdminProfile();
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to update profile.",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update profile.",
        });
      });
  };

  // ── NEW: Payment tab validation — koi bhi rate/limit negative
  // ya khali nahi honi chahiye; percentage rates 0-100 ke andar ──
  const validatePaymentSettings = () => {
    let valid = true;
    const newErrors = { commissionRate: "", deliveryDeductionRate: "", sellerWithdrawLimit: "", deliveryTopupLimit: "", minimumWalletBalance: "", sellerCancellationPenalty: "", deliveryCancellationPenalty: "", customerCancellationFeePercent: "" };

    const checkPercentage = (key, label) => {
      const v = paymentSettings[key];
      if (v === "" || v === null) {
        newErrors[key] = `${label} is required`;
        valid = false;
      } else if (Number(v) < 0 || Number(v) > 100) {
        newErrors[key] = `${label} must be between 0 and 100`;
        valid = false;
      }
    };

    const checkAmount = (key, label) => {
      const v = paymentSettings[key];
      if (v === "" || v === null) {
        newErrors[key] = `${label} is required`;
        valid = false;
      } else if (Number(v) < 0) {
        newErrors[key] = `${label} cannot be negative`;
        valid = false;
      }
    };

    checkPercentage("commissionRate", "Commission rate");
    checkPercentage("deliveryDeductionRate", "Delivery deduction rate");
    checkAmount("sellerWithdrawLimit", "Seller withdraw limit");
    checkAmount("deliveryTopupLimit", "Driver topup limit");
    checkAmount("minimumWalletBalance", "Minimum wallet balance");
    checkAmount("sellerCancellationPenalty", "Seller cancellation penalty");
    checkAmount("deliveryCancellationPenalty", "Delivery cancellation penalty");
    checkPercentage("customerCancellationFeePercent", "Customer cancellation fee");

    setPaymentErrors(newErrors);
    return valid;
  };

  // ── updatePaymentSettings — sirf superadmin (issuperadmin=1) call kar sakta hai ──
  const updatePaymentSettings = () => {
    const formData = new FormData();
    formData.append("commission_rate", paymentSettings.commissionRate);
    formData.append("delivery_deduction_rate", paymentSettings.deliveryDeductionRate);
    formData.append("seller_withdraw_limit", paymentSettings.sellerWithdrawLimit);
    formData.append("delivery_topup_limit", paymentSettings.deliveryTopupLimit);
    formData.append("minimum_wallet_balance", paymentSettings.minimumWalletBalance);
    formData.append("seller_cancellation_penalty", paymentSettings.sellerCancellationPenalty);
    formData.append("delivery_cancellation_penalty", paymentSettings.deliveryCancellationPenalty);
    formData.append("customer_cancellation_fee_percent", paymentSettings.customerCancellationFeePercent);

    axios
      .post(`${baseUrl}/admin/profile/updatePaymentSettings`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Payment settings updated successfully!",
          });
          viewAdminProfile();
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.message || "Failed to update payment settings.",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update payment settings.",
        });
      });
  };

  // ══════════════════════════════════════════════════════════════════════
  // BANK ACCOUNTS (Payout) — same pattern/endpoints style as Seller Settings,
  // just under /admin/bank/... instead of /seller/bank/...
  // ══════════════════════════════════════════════════════════════════════
  const fetchBankAccounts = () => {
    axios
      .get(`${baseUrl}/admin/bank/viewAllBankAccounts`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        const data = response.data;
        if (data.hasOwnProperty("error")) {
          console.log(data.error);
        } else {
          setBankAccounts(data.accounts || []);
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (!authToken) return;
    fetchBankAccounts();
  }, [authToken]);

  const validateBankForm = () => {
    let valid = true;

    if (!bankName) {
      setBankNameError("Please select a bank");
      valid = false;
    } else setBankNameError("");

    if (!accountTitle?.trim()) {
      setAccountTitleError("Account title is required");
      valid = false;
    } else setAccountTitleError("");

    if (!accountNumber?.trim()) {
      setAccountNumberError("Account number is required");
      valid = false;
    } else if (!/^[0-9]{5,}$/.test(accountNumber.trim())) {
      setAccountNumberError("Account number must be at least 5 digits");
      valid = false;
    } else setAccountNumberError("");

    return valid;
  };

  const addBankAccount = () => {
    if (!validateBankForm()) return;
    const formData = new FormData();
    formData.append("bankname", bankName);
    formData.append("accounttitle", accountTitle);
    formData.append("accountnumber", accountNumber);
    formData.append("isprimary", isPrimary ? 1 : 0);

    axios
      .post(`${baseUrl}/admin/bank/addBankAccount`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (response.data.success) {
          fetchBankAccounts();
          Swal.fire("Added!", "Bank account added", "success");
          setShowBankForm(false);
          setSelectedBank(null);
        } else {
          Swal.fire({ icon: "error", title: "Error", text: response.data.message });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({ icon: "error", title: "Error", text: "Failed to add bank account." });
      });
  };

  const updateBankAccount = () => {
    if (!validateBankForm()) return;
    const formData = new FormData();
    formData.append("id", selectedBank.id);
    formData.append("bankname", bankName);
    formData.append("accounttitle", accountTitle);
    formData.append("accountnumber", accountNumber);
    formData.append("isprimary", isPrimary ? 1 : 0);

    axios
      .post(`${baseUrl}/admin/bank/updateBankAccount`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (response.data.success) {
          fetchBankAccounts();
          Swal.fire("Updated!", "Bank account updated", "success");
          setShowBankForm(false);
          setSelectedBank(null);
        } else {
          Swal.fire({ icon: "error", title: "Error", text: response.data.message });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({ icon: "error", title: "Error", text: "Failed to update bank account." });
      });
  };

  const deleteBankAccount = (id) => {
    const formData = new FormData();
    formData.append("id", id);

    axios
      .post(`${baseUrl}/admin/bank/deleteBankAccount`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (response.data.success) {
          fetchBankAccounts();
          Swal.fire("Deleted!", "Bank account deleted", "success");
        } else {
          Swal.fire({ icon: "error", title: "Error", text: response.data.message });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({ icon: "error", title: "Error", text: "Failed to delete bank account." });
      });
  };

  // ── NEW: Security tab validation ──
  const validateAdminPasswordChange = () => {
    let valid = true;

    if (!currentPassword) {
      setCurrentPasswordError("Please enter your current password");
      valid = false;
    } else setCurrentPasswordError("");

    const newPassErr = regExpChecker("password", newPassword);
    if (!newPassword) {
      setNewPasswordError("New password is required");
      valid = false;
    } else if (newPassword.length < 8) {
      setNewPasswordError("Password must be at least 8 characters");
      valid = false;
    } else if (newPassErr) {
      setNewPasswordError(newPassErr);
      valid = false;
    } else setNewPasswordError("");

    if (!confirmPassword) {
      setConfirmPasswordError("Please confirm your new password");
      valid = false;
    } else if (newPassword !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      valid = false;
    } else setConfirmPasswordError("");

    return valid;
  };

  const changeAdminPassword = () => {
    const formData = new FormData();
    formData.append("currentPassword", currentPassword);
    formData.append("newPassword", newPassword);
    axios
      .post(`${baseUrl}/admin/profile/changeAdminPassword`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Password changed successfully!",
          });
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to update Password",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update profile.",
        });
      });
  };
  const changeNotificationSetting = () => {
    const formData = new FormData();

    formData.append("emailNotification", emailNotification ? 1 : 0);
    formData.append("inAppNotification", inAppNotification ? 1 : 0);

    axios
      .post(`${baseUrl}/admin/profile/changeNotificationSetting`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data.success == true) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Notification settings updated!",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to update notification settings",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update notification settings.",
        });
      });
  };

  // ── Sirf superadmin (issuperadmin = 1) hi payment settings edit kar sakta hai ──
  const isSuperAdmin = adminProfile?.issuperadmin == 1;

  if (loading) {
    return (
      <AdminLayout>
        <SettingsPageSkeleton />
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <Container fluid className="profile-container">
        {/* Header - Same as Profile */}
        <div className="profile-header">
          <div className="profile-header-left">
            <div className="profile-icon-wrapper">
              <FaUser size={28} />
            </div>
            <div>
              <h2 className="profile-page-title">Platform Settings</h2>
              <p className="profile-subtitle">
                Configure and manage your platform settings
              </p>
            </div>
          </div>
        </div>

        <Row className="g-4">
          {/* ── Left Sidebar - Same as Profile ── */}
          <Col xs={12} lg={4} xl={3}>
            <Card className="profile-sidebar-card">
              <Card.Body className="text-center">
                <div className="settings-admin-avatar">
                  <FaUser size={40} />
                </div>
                <h5 className="profile-name">{name}</h5>
                <p className="profile-email">{email}</p>
                <p className="profile-phone">{phone}</p>
              </Card.Body>
            </Card>
          </Col>

          {/* ── Right Content - Same as Profile ── */}
          <Col xs={12} lg={8} xl={9}>
            <Card className="profile-content-card">
              <Card.Body>
                <Tab.Container
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                >
                  {/* Tabs Nav - Same as Profile */}
                  <Nav variant="pills" className="profile-tabs mb-3">
                    <Nav.Item>
                      <Nav.Link eventKey="profile">
                        <FaUser className="me-2" />
                        My Profile
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="payment">
                        <FaDollarSign className="me-2" />
                        Payment
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="bank-accounts">
                        <FaUniversity className="me-2" />
                        Bank Accounts
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="security">
                        <FaLock className="me-2" />
                        Security
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="notifications">
                        <FaBell className="me-2" />
                        Notifications
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>

                  <Tab.Content className="profile-tab-content">
                    {/* ══ PROFILE TAB ══════════════════════════════════════════ */}
                    <Tab.Pane eventKey="profile">
                      <div className="form-section-header">
                        <h5 className="form-section-title">
                          Personal Information
                        </h5>
                        {!isProfileEditing && (
                          <button
                            type="button"
                            className="profile-edit-btn"
                            onClick={() => setIsProfileEditing(true)}
                          >
                            <FaEdit size={14} />
                            Edit
                          </button>
                        )}
                      </div>

                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (!validateAdminProfile()) return;
                          updateAdminProfile();
                          setIsProfileEditing(false);
                        }}
                      >
                        <Row className="g-3">
                          <Col md={6}>
                            <Form.Label className="form-label">
                              Full Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              className="form-input"
                              value={name}
                              style={isProfileEditing && nameError ? errBorder : undefined}
                              onChange={(e) => {
                                setName(e.target.value);
                                if (isProfileEditing) {
                                  setNameError(e.target.value ? (regExpChecker("username", e.target.value) || "") : "Full name is required");
                                }
                              }}
                              disabled={!isProfileEditing}
                            />
                            {isProfileEditing && nameError && <p style={errText}>{nameError}</p>}
                          </Col>

                          <Col md={6}>
                            <Form.Label className="form-label">
                              Email Address
                            </Form.Label>
                            <Form.Control
                              type="email"
                              className="form-input"
                              value={email}
                              style={isProfileEditing && emailError ? errBorder : undefined}
                              onChange={(e) => {
                                setEmail(e.target.value);
                                if (isProfileEditing) {
                                  setEmailError(e.target.value ? (regExpChecker("email", e.target.value) || "") : "Email is required");
                                }
                              }}
                              disabled={!isProfileEditing}
                            />
                            {isProfileEditing && emailError && <p style={errText}>{emailError}</p>}
                          </Col>

                          <Col md={6}>
                            <Form.Label className="form-label">
                              Phone Number
                            </Form.Label>
                            <Form.Control
                              type="tel"
                              className="form-input"
                              value={phone}
                              style={isProfileEditing && phoneError ? errBorder : undefined}
                              onChange={(e) => {
                                setPhone(e.target.value);
                                if (isProfileEditing) {
                                  setPhoneError(e.target.value ? (regExpChecker("phoneNumber", e.target.value) || "") : "");
                                }
                              }}
                              disabled={!isProfileEditing}
                            />
                            {isProfileEditing && phoneError && <p style={errText}>{phoneError}</p>}
                          </Col>

                          {/* Save/Cancel - only in edit mode */}
                          {isProfileEditing && (
                            <Col xs={12} className="d-flex gap-2">
                              <button type="submit" className="btn btn-success">
                                <FaSave /> Save Changes
                              </button>
                              <button
                                type="button"
                                className="profile-cancel-btn"
                                onClick={() => {
                                  setIsProfileEditing(false);
                                  setNameError("");
                                  setEmailError("");
                                  setPhoneError("");
                                  viewAdminProfile();
                                }}
                              >
                                Cancel
                              </button>
                            </Col>
                          )}
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* ══ PAYMENT TAB ══════════════════════════════════════════ */}
                    <Tab.Pane eventKey="payment">
                      <div className="form-section-header">
                        <h5 className="form-section-title">
                          Payment Configuration
                        </h5>
                        {/* ── Sirf superadmin ko Edit button dikhega ── */}
                        {!isPaymentEditing && isSuperAdmin && (
                          <button
                            type="button"
                            className="profile-edit-btn"
                            onClick={() => setIsPaymentEditing(true)}
                          >
                            <FaEdit size={14} />
                            Edit
                          </button>
                        )}
                      </div>

                      {/* ── Superadmin nahi hai to warning dikhayen ── */}
                      {!isSuperAdmin && (
                        <p className="ksa-settings-input-hint mb-3">
                          🔒 Only superadmin can edit payment settings.
                        </p>
                      )}

                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (!validatePaymentSettings()) return;
                          updatePaymentSettings();
                          setIsPaymentEditing(false);
                        }}
                      >
                        <Row className="g-3">
                          <Col xs={12} md={6}>
                            <Form.Label className="form-label">
                              Platform Commission Rate (%)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              className="form-input"
                              value={paymentSettings.commissionRate}
                              style={isPaymentEditing && paymentErrors.commissionRate ? errBorder : undefined}
                              onChange={(e) => {
                                const v = e.target.value;
                                setPaymentSettings({ ...paymentSettings, commissionRate: v });
                                let err = "";
                                if (v === "") err = "Commission rate is required";
                                else if (Number(v) < 0 || Number(v) > 100) err = "Commission rate must be between 0 and 100";
                                setPaymentErrors((prev) => ({ ...prev, commissionRate: err }));
                              }}
                              disabled={!isPaymentEditing || !isSuperAdmin}
                            />
                            {isPaymentEditing && paymentErrors.commissionRate && <p style={errText}>{paymentErrors.commissionRate}</p>}
                            {!isPaymentEditing && (
                              <small className="ksa-settings-input-hint">
                                Percentage cut from seller earnings on each order
                              </small>
                            )}
                          </Col>

                          <Col xs={12} md={6}>
                            <Form.Label className="form-label">
                              Delivery Deduction Rate (%)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              className="form-input"
                              value={paymentSettings.deliveryDeductionRate}
                              style={isPaymentEditing && paymentErrors.deliveryDeductionRate ? errBorder : undefined}
                              onChange={(e) => {
                                const v = e.target.value;
                                setPaymentSettings({ ...paymentSettings, deliveryDeductionRate: v });
                                let err = "";
                                if (v === "") err = "Delivery deduction rate is required";
                                else if (Number(v) < 0 || Number(v) > 100) err = "Delivery deduction rate must be between 0 and 100";
                                setPaymentErrors((prev) => ({ ...prev, deliveryDeductionRate: err }));
                              }}
                              disabled={!isPaymentEditing || !isSuperAdmin}
                            />
                            {isPaymentEditing && paymentErrors.deliveryDeductionRate && <p style={errText}>{paymentErrors.deliveryDeductionRate}</p>}
                            {!isPaymentEditing && (
                              <small className="ksa-settings-input-hint">
                                Percentage cut from delivery man's earnings per delivery
                              </small>
                            )}
                          </Col>

                          <Col xs={12} md={6}>
                            <Form.Label className="form-label">
                              Seller Per Day Withdraw Limit (Rs.)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              className="form-input"
                              value={paymentSettings.sellerWithdrawLimit}
                              style={isPaymentEditing && paymentErrors.sellerWithdrawLimit ? errBorder : undefined}
                              onChange={(e) => {
                                const v = e.target.value;
                                setPaymentSettings({ ...paymentSettings, sellerWithdrawLimit: v });
                                let err = "";
                                if (v === "") err = "Seller withdraw limit is required";
                                else if (Number(v) < 0) err = "Seller withdraw limit cannot be negative";
                                setPaymentErrors((prev) => ({ ...prev, sellerWithdrawLimit: err }));
                              }}
                              placeholder="Enter daily withdraw limit"
                              disabled={!isPaymentEditing || !isSuperAdmin}
                            />
                            {isPaymentEditing && paymentErrors.sellerWithdrawLimit && <p style={errText}>{paymentErrors.sellerWithdrawLimit}</p>}
                            {!isPaymentEditing && (
                              <small className="ksa-settings-input-hint">
                                Maximum amount a seller can withdraw per day
                                (Default: Rs. 50,000)
                              </small>
                            )}
                          </Col>

                          <Col xs={12} md={6}>
                            <Form.Label className="form-label">
                              Driver Wallet Topup Limit (Rs.)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              className="form-input"
                              value={paymentSettings.deliveryTopupLimit}
                              style={isPaymentEditing && paymentErrors.deliveryTopupLimit ? errBorder : undefined}
                              onChange={(e) => {
                                const v = e.target.value;
                                setPaymentSettings({ ...paymentSettings, deliveryTopupLimit: v });
                                let err = "";
                                if (v === "") err = "Driver topup limit is required";
                                else if (Number(v) < 0) err = "Driver topup limit cannot be negative";
                                setPaymentErrors((prev) => ({ ...prev, deliveryTopupLimit: err }));
                              }}
                              placeholder="Enter driver topup limit"
                              disabled={!isPaymentEditing || !isSuperAdmin}
                            />
                            {isPaymentEditing && paymentErrors.deliveryTopupLimit && <p style={errText}>{paymentErrors.deliveryTopupLimit}</p>}
                            {!isPaymentEditing && (
                              <small className="ksa-settings-input-hint">
                                Maximum amount a driver can add to their wallet in a single topup
                              </small>
                            )}
                          </Col>

                          <Col xs={12} md={6}>
                            <Form.Label className="form-label">
                              Minimum Wallet Balance to Get Jobs (Rs.)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              className="form-input"
                              value={paymentSettings.minimumWalletBalance}
                              style={isPaymentEditing && paymentErrors.minimumWalletBalance ? errBorder : undefined}
                              onChange={(e) => {
                                const v = e.target.value;
                                setPaymentSettings({ ...paymentSettings, minimumWalletBalance: v });
                                let err = "";
                                if (v === "") err = "Minimum wallet balance is required";
                                else if (Number(v) < 0) err = "Minimum wallet balance cannot be negative";
                                setPaymentErrors((prev) => ({ ...prev, minimumWalletBalance: err }));
                              }}
                              placeholder="Enter minimum balance required"
                              disabled={!isPaymentEditing || !isSuperAdmin}
                            />
                            {isPaymentEditing && paymentErrors.minimumWalletBalance && <p style={errText}>{paymentErrors.minimumWalletBalance}</p>}
                            {!isPaymentEditing && (
                              <small className="ksa-settings-input-hint">
                                Drivers below this wallet balance won't see any open delivery jobs
                              </small>
                            )}
                          </Col>

                          {/* ── NEW: Cancellation-Penalty Settings ── */}
                          <Col xs={12} md={6}>
                            <Form.Label className="form-label">
                              Seller Cancellation Penalty (Rs.)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              className="form-input"
                              value={paymentSettings.sellerCancellationPenalty}
                              style={isPaymentEditing && paymentErrors.sellerCancellationPenalty ? errBorder : undefined}
                              onChange={(e) => {
                                const v = e.target.value;
                                setPaymentSettings({ ...paymentSettings, sellerCancellationPenalty: v });
                                let err = "";
                                if (v === "") err = "Seller cancellation penalty is required";
                                else if (Number(v) < 0) err = "Seller cancellation penalty cannot be negative";
                                setPaymentErrors((prev) => ({ ...prev, sellerCancellationPenalty: err }));
                              }}
                              placeholder="e.g. 100"
                              disabled={!isPaymentEditing || !isSuperAdmin}
                            />
                            {isPaymentEditing && paymentErrors.sellerCancellationPenalty && <p style={errText}>{paymentErrors.sellerCancellationPenalty}</p>}
                            {!isPaymentEditing && (
                              <small className="ksa-settings-input-hint">
                                Deducted from a seller's earnings if they cancel an order after accepting it
                              </small>
                            )}
                          </Col>

                          <Col xs={12} md={6}>
                            <Form.Label className="form-label">
                              Delivery Cancellation Penalty (Rs.)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              className="form-input"
                              value={paymentSettings.deliveryCancellationPenalty}
                              style={isPaymentEditing && paymentErrors.deliveryCancellationPenalty ? errBorder : undefined}
                              onChange={(e) => {
                                const v = e.target.value;
                                setPaymentSettings({ ...paymentSettings, deliveryCancellationPenalty: v });
                                let err = "";
                                if (v === "") err = "Delivery cancellation penalty is required";
                                else if (Number(v) < 0) err = "Delivery cancellation penalty cannot be negative";
                                setPaymentErrors((prev) => ({ ...prev, deliveryCancellationPenalty: err }));
                              }}
                              placeholder="e.g. 50"
                              disabled={!isPaymentEditing || !isSuperAdmin}
                            />
                            {isPaymentEditing && paymentErrors.deliveryCancellationPenalty && <p style={errText}>{paymentErrors.deliveryCancellationPenalty}</p>}
                            {!isPaymentEditing && (
                              <small className="ksa-settings-input-hint">
                                Deducted from a driver's wallet balance if they cancel a job after accepting it
                              </small>
                            )}
                          </Col>

                          <Col xs={12} md={6}>
                            <Form.Label className="form-label">
                              Customer Cancellation Fee (%)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              className="form-input"
                              value={paymentSettings.customerCancellationFeePercent}
                              style={isPaymentEditing && paymentErrors.customerCancellationFeePercent ? errBorder : undefined}
                              onChange={(e) => {
                                const v = e.target.value;
                                setPaymentSettings({ ...paymentSettings, customerCancellationFeePercent: v });
                                let err = "";
                                if (v === "") err = "Customer cancellation fee is required";
                                else if (Number(v) < 0 || Number(v) > 100) err = "Customer cancellation fee must be between 0 and 100";
                                setPaymentErrors((prev) => ({ ...prev, customerCancellationFeePercent: err }));
                              }}
                              placeholder="e.g. 5"
                              disabled={!isPaymentEditing || !isSuperAdmin}
                            />
                            {isPaymentEditing && paymentErrors.customerCancellationFeePercent && <p style={errText}>{paymentErrors.customerCancellationFeePercent}</p>}
                            {!isPaymentEditing && (
                              <small className="ksa-settings-input-hint">
                                % deducted from the refund if a customer cancels a paid order (before it's ready for pickup)
                              </small>
                            )}
                          </Col>

                          {/* Save/Cancel - only in edit mode */}
                          {isPaymentEditing && isSuperAdmin && (
                            <Col xs={12} className="d-flex gap-2">
                              <Button
                                type="submit"
                                variant="primary"
                                icon={<FaSave />}
                              >
                                Save Changes
                              </Button>
                              <button
                                type="button"
                                className="profile-cancel-btn"
                                onClick={() => {
                                  setIsPaymentEditing(false);
                                  setPaymentErrors({ commissionRate: "", deliveryDeductionRate: "", sellerWithdrawLimit: "", deliveryTopupLimit: "", minimumWalletBalance: "", sellerCancellationPenalty: "", deliveryCancellationPenalty: "", customerCancellationFeePercent: "" });
                                  viewAdminProfile();
                                }}
                              >
                                Cancel
                              </button>
                            </Col>
                          )}
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* ══ BANK ACCOUNTS TAB ══════════════════════════════════════ */}
                    <Tab.Pane eventKey="bank-accounts">
                      {!showBankForm ? (
                        <>
                          <div className="form-section-header">
                            <h5 className="form-section-title">Bank Accounts</h5>
                            <button
                              type="button"
                              className="profile-edit-btn"
                              onClick={() => {
                                setSelectedBank(null);
                                setBankName("");
                                setAccountTitle("");
                                setAccountNumber("");
                                setIsPrimary(false);
                                setBankNameError("");
                                setAccountTitleError("");
                                setAccountNumberError("");
                                setShowBankForm(true);
                              }}
                            >
                              <FaPlus size={14} />
                              Add Account
                            </button>
                          </div>
                          <p className="ksa-settings-input-hint mb-3">
                            This is the account delivery riders and sellers will see
                            when they need to send payments/refunds to KisaanMart.
                            Mark one as "Primary" — that's the one shown across the app.
                          </p>

                          <div className="seller-bank-list">
                            {bankAccounts.length === 0 && (
                              <div className="seller-empty-state">
                                <FaUniversity className="seller-empty-icon" />
                                <p>No bank accounts added yet</p>
                              </div>
                            )}
                            {bankAccounts.map((account) => (
                              <div key={account.id} className="settings-item seller-bank-item">
                                <div className="settings-item-info">
                                  <div className="seller-bank-name-row">
                                    <FaUniversity style={{ color: "var(--secondary-color)", marginRight: 8 }} />
                                    <span className="seller-bank-name">{account.bankname}</span>
                                    {account.isprimary == 1 && (
                                      <span className="seller-primary-badge">Primary</span>
                                    )}
                                  </div>
                                  <div className="seller-bank-details">
                                    <span>Title: <strong>{account.accounttitle}</strong></span>
                                    <span>Account: <strong>{account.accountnumber}</strong></span>
                                  </div>
                                </div>
                                <div className="seller-bank-actions">
                                  <button
                                    className="seller-action-btn seller-action-edit"
                                    onClick={() => {
                                      setSelectedBank(account);
                                      setBankName(account.bankname);
                                      setAccountTitle(account.accounttitle);
                                      setAccountNumber(account.accountnumber);
                                      setIsPrimary(account.isprimary == 1);
                                      setBankNameError("");
                                      setAccountTitleError("");
                                      setAccountNumberError("");
                                      setShowBankForm(true);
                                    }}
                                  >
                                    <FaEdit />
                                  </button>
                                  <button
                                    className="seller-action-btn seller-action-delete"
                                    onClick={async () => {
                                      const r = await Swal.fire({
                                        title: "Delete Bank Account?",
                                        text: "This action cannot be undone",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#dc3545",
                                        cancelButtonColor: "#6b7280",
                                        confirmButtonText: "Yes, Delete",
                                      });
                                      if (r.isConfirmed) deleteBankAccount(account.id);
                                    }}
                                  >
                                    <FaTrash />
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="form-section-header">
                            <h5 className="form-section-title">
                              {selectedBank ? "Edit Bank Account" : "Add Bank Account"}
                            </h5>
                            <button
                              type="button"
                              className="seller-close-btn"
                              onClick={() => { setShowBankForm(false); setSelectedBank(null); }}
                            >
                              <FaTimes />
                            </button>
                          </div>

                          <Row className="g-3 mt-2">
                            <Col xs={12}>
                              <Form.Label className="form-label">Bank Name *</Form.Label>
                              <Form.Select
                                value={bankName}
                                style={bankNameError ? errBorder : undefined}
                                onChange={(e) => {
                                  setBankName(e.target.value);
                                  setBankNameError(e.target.value ? "" : "Please select a bank");
                                }}
                                className="form-select-custom"
                              >
                                <option value="">Select Bank</option>
                                <option>Habib Bank Limited (HBL)</option>
                                <option>MCB Bank Limited</option>
                                <option>Allied Bank Limited</option>
                                <option>United Bank Limited (UBL)</option>
                                <option>National Bank of Pakistan</option>
                                <option>Meezan Bank</option>
                                <option>Faysal Bank</option>
                                <option>Askari Bank</option>
                                <option>Bank Alfalah</option>
                                <option>Bank Al Habib</option>
                                <option>Standard Chartered Bank</option>
                                <option>JS Bank</option>
                                <option>Soneri Bank</option>
                                <option>Summit Bank</option>
                                <option>Silk Bank</option>
                                <option>Al Baraka Bank</option>
                                <option>Dubai Islamic Bank Pakistan</option>
                                <option>Bank of Punjab</option>
                                <option>Bank of Khyber</option>
                                <option>Sindh Bank</option>
                              </Form.Select>
                              {bankNameError && <p style={errText}>{bankNameError}</p>}
                            </Col>
                            <Col xs={12} md={6}>
                              <Form.Label className="form-label">Account Title *</Form.Label>
                              <Form.Control
                                type="text"
                                value={accountTitle}
                                placeholder="Enter account title"
                                style={accountTitleError ? errBorder : undefined}
                                onChange={(e) => {
                                  setAccountTitle(e.target.value);
                                  setAccountTitleError(e.target.value.trim() ? "" : "Account title is required");
                                }}
                                className="form-input"
                              />
                              {accountTitleError && <p style={errText}>{accountTitleError}</p>}
                            </Col>
                            <Col xs={12} md={6}>
                              <Form.Label className="form-label">Account Number *</Form.Label>
                              <Form.Control
                                type="text"
                                value={accountNumber}
                                placeholder="Enter account number"
                                style={accountNumberError ? errBorder : undefined}
                                onChange={(e) => {
                                  setAccountNumber(e.target.value);
                                  const v = e.target.value.trim();
                                  if (!v) setAccountNumberError("Account number is required");
                                  else if (!/^[0-9]{5,}$/.test(v)) setAccountNumberError("Account number must be at least 5 digits");
                                  else setAccountNumberError("");
                                }}
                                className="form-input"
                              />
                              {accountNumberError && <p style={errText}>{accountNumberError}</p>}
                            </Col>
                            <Col xs={12}>
                              <div className="seller-checkbox-row">
                                <Form.Check
                                  type="checkbox"
                                  id="isPrimaryAdminBank"
                                  checked={isPrimary}
                                  onChange={(e) => setIsPrimary(e.target.checked)}
                                />
                                <label htmlFor="isPrimaryAdminBank" className="seller-checkbox-label">
                                  Set as primary account
                                </label>
                              </div>
                            </Col>
                          </Row>

                          <div className="seller-form-footer">
                            <button
                              type="button"
                              className="profile-cancel-btn"
                              onClick={() => { setShowBankForm(false); setSelectedBank(null); }}
                            >
                              Cancel
                            </button>
                            <Button
                              variant="primary"
                              icon={<FaSave />}
                              onClick={() => (selectedBank ? updateBankAccount() : addBankAccount())}
                            >
                              {selectedBank ? "Update Account" : "Save Account"}
                            </Button>
                          </div>
                        </>
                      )}
                    </Tab.Pane>

                    {/* ══ SECURITY TAB ══════════════════════════════════════════ */}
                    <Tab.Pane eventKey="security">
                      <h5 className="form-section-title">Change Password</h5>

                      {/* Security Tips - Same as Profile */}
                      <div className="profile-security-tips mb-4">
                        <p className="security-tip-title">
                          🔒 Password Requirements:
                        </p>
                        <ul className="security-tip-list">
                          <li
                            className={newPassword.length >= 8 ? "tip-ok" : ""}
                          >
                            At least 8 characters
                          </li>
                          <li
                            className={
                              /[A-Z]/.test(newPassword) ? "tip-ok" : ""
                            }
                          >
                            At least one uppercase letter
                          </li>
                          <li
                            className={
                              /[0-9]/.test(newPassword) ? "tip-ok" : ""
                            }
                          >
                            At least one number
                          </li>
                          <li
                            className={
                              /[^a-zA-Z0-9]/.test(newPassword) ? "tip-ok" : ""
                            }
                          >
                            At least one special character
                          </li>
                        </ul>
                      </div>

                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (!validateAdminPasswordChange()) return;
                          changeAdminPassword();
                        }}
                      >
                        <Row className="g-3">
                          {[
                            {
                              key: "current",
                              label: "Current Password",
                              value: currentPassword,
                              setter: setCurrentPassword,
                              error: currentPasswordError,
                            },
                            {
                              key: "new",
                              label: "New Password",
                              value: newPassword,
                              setter: setNewPassword,
                              error: newPasswordError,
                            },
                            {
                              key: "confirm",
                              label: "Confirm Password",
                              value: confirmPassword,
                              setter: setConfirmPassword,
                              error: confirmPasswordError,
                            },
                          ].map(({ key, label, value, setter, error }) => (
                            <Col xs={12} md={6} key={key}>
                              <Form.Label className="form-label">
                                <FaLock className="me-2" />
                                {label}
                              </Form.Label>
                              <div className="profile-password-wrapper">
                                <Form.Control
                                  type={
                                    showPasswords[key] ? "text" : "password"
                                  }
                                  value={value}
                                  style={error ? errBorder : undefined}
                                  onChange={(e) => {
                                    const v = e.target.value;
                                    setter(v);

                                    if (key === "current") {
                                      setCurrentPasswordError(v ? "" : "Please enter your current password");
                                    } else if (key === "new") {
                                      if (!v) setNewPasswordError("New password is required");
                                      else if (v.length < 8) setNewPasswordError("Password must be at least 8 characters");
                                      else setNewPasswordError(regExpChecker("password", v) || "");
                                      if (confirmPassword) {
                                        setConfirmPasswordError(confirmPassword === v ? "" : "Passwords do not match");
                                      }
                                    } else if (key === "confirm") {
                                      if (!v) setConfirmPasswordError("Please confirm your new password");
                                      else setConfirmPasswordError(v === newPassword ? "" : "Passwords do not match");
                                    }
                                  }}
                                  placeholder={label}
                                  className="form-input profile-password-input"
                                />
                                <button
                                  type="button"
                                  className="profile-password-toggle"
                                  onClick={() => togglePass(key)}
                                >
                                  {showPasswords[key] ? "🙈" : "👁"}
                                </button>
                              </div>
                              {error && <p style={errText}>{error}</p>}

                              {/* Strength bar */}
                              {key === "new" && newPassword.length > 0 && (
                                <div className="profile-password-strength mt-2">
                                  <div
                                    className="strength-bar"
                                    style={{
                                      width: `${Math.min(100, (newPassword.length / 12) * 100)}%`,
                                      background:
                                        newPassword.length < 6
                                          ? "#dc3545"
                                          : newPassword.length < 10
                                            ? "#ffc107"
                                            : "var(--gradient-primary)",
                                    }}
                                  />
                                  <span className="strength-label">
                                    {newPassword.length < 6
                                      ? "Weak"
                                      : newPassword.length < 10
                                        ? "Medium"
                                        : "Strong"}
                                  </span>
                                </div>
                              )}

                              {/* Match indicator */}
                              {key === "confirm" &&
                                confirmPassword.length > 0 && (
                                  <p
                                    className={`profile-password-match mt-1 ${
                                      newPassword === confirmPassword
                                        ? "match-ok"
                                        : "match-fail"
                                    }`}
                                  >
                                    {newPassword === confirmPassword
                                      ? "✓ Passwords match"
                                      : "✗ Passwords do not match"}
                                  </p>
                                )}
                            </Col>
                          ))}

                          <Col xs={12}>
                            <Button
                              type="submit"
                              variant="primary"
                              icon={<FaLock />}
                            >
                              Update Password
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* ══ NOTIFICATIONS TAB ═════════════════════════════════════ */}
                    <Tab.Pane eventKey="notifications">
                      <h5 className="form-section-title">
                        Notification Preferences
                      </h5>
                      <p className="form-section-subtitle">
                        Configure which notifications you want to receive
                      </p>

                      <div className="profile-notif-list">
                        <div className="profile-notif-list">
                          <div className="profile-notif-item">
                            <div className="profile-notif-info">
                              <p className="profile-notif-label">
                                Email Notifications
                              </p>

                              <p className="profile-notif-desc">
                                Receive notifications via email
                              </p>
                            </div>

                            <Form.Check
                              type="switch"
                              className="custom-switch"
                              checked={emailNotification}
                              onChange={() => {
                                setEmailNotification(!emailNotification);
                              }}
                            />
                          </div>

                          <div className="profile-notif-item">
                            <div className="profile-notif-info">
                              <p className="profile-notif-label">
                                In-App Notifications
                              </p>

                              <p className="profile-notif-desc">
                                Receive notifications within platform
                              </p>
                            </div>

                            <Form.Check
                              type="switch"
                              className="custom-switch"
                              checked={inAppNotification}
                              onChange={() => {
                                setInAppNotification(!inAppNotification);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-4">
                        <Button
                          variant="primary"
                          icon={<FaSave />}
                          onClick={() => {
                            changeNotificationSetting();
                          }}
                        >
                          Save Preferences
                        </Button>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </AdminLayout>
  );
};

export default SystemSettings;
